// Copyright © Aptos
// SPDX-License-Identifier: Apache-2.0

export const DEFAULT_BACKEND_URL = 'https://identityconnect.com';
